module.exports = __webpack_public_path__ + "img/session-expire.deae9850.jpg";